<template>
  <div v-if="data">
    <UiModal 
      :open="status_show_popup_sell" 
      @close="status_show_popup_sell = false"
      >
      <div class="pt-5 px-5 pb-4">

        <h4 class="text-center mb-5" style="line-height: 1.5em;">
          {{lg('',{
            en: 'You are about to Sell',
            zh: '',
          })}}
        </h4>

        <horseItem
          :data="data"
          :cfg_hide_more="true"
        />

        <div class="py-4 mt-4">
          <div class="d-flex align-items-center mb-4">
            <div class="text-small op4" style="width: 70%;">
              {{lg('',{
                en: 'SELL PRICE',
                zh: '卖出价格',
              })}}
            </div>
            <input 
              v-model="form.price"
              style="width: 30%;"
              type="number" 
              class="form-control"
              :min="price_min"
              :placeholder="`${price_min}`"
            >
          </div>

          <!-- <div 
            class="op4 text-small"
            style="line-height: 16px;"
            >
            Please note: For the duration of the stud service,
            your racehorse cannot be placed into the marketplace for sale or compete in races.
          </div> -->

          <div class="mt-5 row">

            <div class="col-6">
              <span 
                @click="status_show_popup_sell = false"
                class="btn btn-outline-primary w-100"
                >
                {{lg('',{
                  en: 'Cancel',
                  zh: '',
                })}}
              </span>
            </div>
            <div class="col-6">
              <span 
                @click="nextSell()"
                class="btn btn-primary w-100"
                >
                {{lg('',{
                  en: 'Next',
                  zh: '',
                })}}
              </span>
            </div>
            
          </div>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import horseItem from '../_cp_busi/horse_item.vue'

export default {
  name: 'popupBreed',
  components: {
    horseItem,
  },
  props: [],
  data() {
    return {
      status_show_popup_sell: false,

      price_min: 0,

      form: {
        price: 0,
      },
    }
  },
  computed: {
    data(){
      return this.$store.state.dataBus.data_on_sell
    },

    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {
    data(val){
      if(val){
        this.popupShow()
      }
      else{
        this.status_show_popup_sell = false
        this.clearForm()
      }
    },
    'status_show_popup_sell'(val){
      if(!val){
        this.$store.commit('setDataBusKey',{
          data_on_sell: null,
        })
        this.clearForm()
      }
    },
  },
  methods: {
    ...mapActions([
      'createAskOrder',
    ]),
    clearForm(){
      this.price_min = 0
      this.form.price = ''
    },
    popupHide(){
      this.clearForm()
      this.status_show_popup_sell = false
    },
    popupShow(){
      let v = this
      v.status_show_popup_sell = true
      v.getPriceMin()
    },
    async nextSell(){
      let v = this

      if(isNaN(this.form.price)){
        return
      }

      await v.createAskOrder({
        address_my: this.address_my,
        form_price: this.form.price + '',
        horse_data: this.data,
      })

      v.popupHide()
    },
    // async getPriceMin(){
    //   let v = this

    //   let res = await v.getMiniAuctionPrice({
    //     horse_data: v.data,
    //   })
      
    //   v.price_min = parseFloat(res)
    //   if(v.form.price < v.price_min){
    //     v.form.price = v.price_min
    //   }
    // },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>